import type { ReactNode } from 'react'
import clsx from 'clsx'
import { InlineMessage } from '@/components/inline-message/InlineMessage'

/** Signals view-only permissions or a temporary editing reservation. */
export default function MatterRecordReadOnlyNotice({
  icon,
  shape = 'strip',
  tone = 'neutral',
  headline,
  message,
}: {
  icon: ReactNode
  /** 'strip' fills its container; 'pill' hugs its content for inline placement. */
  shape?: 'strip' | 'pill'
  /** Informational blue for an editing reservation; neutral for permission-only notices. */
  tone?: 'neutral' | 'info'
  /** Optional bold headline shown before the message. */
  headline?: string
  message: string
}) {
  return (
    <InlineMessage
      variant={tone}
      icon={icon}
      className={clsx(
        'border font-normal',
        tone === 'info' ? 'border-brand-100 text-brand-800 py-1 min-w-0 break-words' : 'border-brand-neutral-200 text-brand-neutral-800',
        shape === 'pill' && 'inline-flex py-1',
        shape === 'pill' && tone === 'neutral' && 'whitespace-nowrap'
      )}
    >
      {headline != null && <span className="font-semibold">{headline} </span>}
      {message}
    </InlineMessage>
  )
}
